// helpers to calculate vectors
const toRadians = (degree: number) => degree * (Math.PI / 180)
export default toRadians
